import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/landing-animation.json';
import './LandingPage.css';

const LandingPage = ({ onAnimationComplete }) => {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
      if (onAnimationComplete) {
        onAnimationComplete();
      }
    }, 6000);

    return () => clearTimeout(timer);
  }, [onAnimationComplete]);

  if (!showAnimation) {
    return null;
  }

  return (
    <div className="landing-page">
      <div className="animation-container">
        <Lottie 
          animationData={animationData}
          loop={true}
          autoplay={true}
        />
      </div>
    </div>
  );
};

export default LandingPage;

